import full from "../../assets/images/full.svg";
import drawer from "../../assets/images/drawer.svg";
import close from "../../assets/images/close.svg";

const DrawerHeader = ({ sizeValue, setSizeValue, onClose, ...props }) => {
  const toggleSize = () => {
    if (sizeValue === "full") {
      localStorage.removeItem("drawer-previous-size");
      setSizeValue(props?.actualSize);
    } else {
      localStorage.setItem("drawer-previous-size", "full");
      setSizeValue("full");
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="p-6 py-2 bg-gray-100 border-b border-gray-300 divide-x divide-gray-400 flex items-center">
      <div className="flex grow">
        {props?.heading && (
          <div className="font-semibold text-base">{props?.heading}</div>
        )}
      </div>
      <div className="flex items-center gap-1 md:gap-2 ml-auto w-fit pl-2">
        <button type="button" onClick={toggleSize} className="h-5 w-5">
          <img alt="" src={sizeValue === "full" ? drawer : full} />
        </button>
        {/* <button type="button" onClick={handleClose} className="h-5 w-5">
          <img alt="" src={close} />
        </button> */}
      </div>
    </div>
  );
};

export default DrawerHeader;
